import AdminPanel from '@/pages/admin-panel/AdminPanel';

export default AdminPanel;
